import { render, staticRenderFns } from "./DashboardUnidade2.vue?vue&type=template&id=c1933bc0&scoped=true"
import script from "./DashboardUnidade2.vue?vue&type=script&lang=js"
export * from "./DashboardUnidade2.vue?vue&type=script&lang=js"
import style0 from "./DashboardUnidade2.vue?vue&type=style&index=0&id=c1933bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1933bc0",
  null
  
)

export default component.exports